import React from 'react';
import { sprintf } from 'sprintf';

import { CDN_ASSETS_URL } from 'constants/global';

type Props = {};

export const HeroLead: React.FC<Props> = () => (
  <div className='container hero-lead'>
    <div className='row mx-auto d-flex flex-wrap flex-md-nowrap align-items-center justify-content-center'>
      <img
        src={`${CDN_ASSETS_URL}nft-landing-page/eth-animation.gif`}
        alt={'ETH symbol'}
        className='mx-3 pb-1 eth-symbol'
      />
      <p
        className='standfirst standfirst--lead mx-auto mb-0 lh-regular text-center text-md-left'
        dangerouslySetInnerHTML={{
          __html: sprintf(
            'Sedition NFTs have arrived. Every month, we select a few artworks that can be transferred to the Ethereum blockchain. Join our %sDiscord%s server to be the first to know which artworks will be mintable next.',
            '<a class="link link-border" href="https://discord.gg/2cDMwZzVUm">',
            '</a>',
          ),
        }}
      />
    </div>
  </div>
);
